//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useContext } from 'react';
import { SettingsContext } from '@/contexts/SettingsContext';

// Access the settings UI controller: whether the settings modal is open and
// which section is shown, plus the open/close/navigate actions.
export function useSettings() {
  const context = useContext(SettingsContext);
  if (!context)
    throw new Error('useSettings must be used within a SettingsProvider');

  return context;
}
